module.exports = __webpack_public_path__ + "img/avatar-1.6eed60cf.png";